import React from 'react';

import { useAbTestProgressBarWithReco } from '@hooks';
import { ReactFCV } from '@types';

import { ECartPageState, useCartPageContext } from '../../context';
import { messages } from '../../messages';

import { StyledCartFreeDeliveryWrapper, StyledCartFreeDeliveryWrapperWithReco } from './styled';
import { calculateMaxLimit, shouldBeRendered } from './utils';

export const CartFreeDeliveryWrapper: ReactFCV = () => {
  const {
    state: {
      pricesSummary: { priceProductsSummary, discountWithoutDelivery },
      benefits,
    },
    settings: {
      freeDelivery,
      freeDeliveryGlobalFrom,
      freeDeliveryGlobalTo,
      freeDeliveryGlobalLimit,
      minimalPriceLimit,
    },
    actions: { setCartPageState },
  } = useCartPageContext();

  const isMinimalPriceLimit = minimalPriceLimit > 0;

  const shouldBeRender = shouldBeRendered(
    isMinimalPriceLimit,
    freeDelivery,
    freeDeliveryGlobalFrom,
    freeDeliveryGlobalTo,
    benefits,
  );

  const { isWithReco } = useAbTestProgressBarWithReco();

  if (!shouldBeRender) {
    return null;
    // free delivery is DISABLED but delivery type priceLimit is active
    // free delivery is ENABLED and delivery type priceLimit is active and lower thant global limit
  }

  return isWithReco ? (
    <StyledCartFreeDeliveryWrapperWithReco
      data-testid="cart-free-delivery"
      price={priceProductsSummary - discountWithoutDelivery}
      maxLimit={calculateMaxLimit(
        isMinimalPriceLimit,
        minimalPriceLimit,
        freeDelivery,
        freeDeliveryGlobalLimit,
        freeDeliveryGlobalFrom,
        freeDeliveryGlobalTo,
        benefits,
      )}
      messages={messages}
      onLinkClick={() => setCartPageState(ECartPageState.FREE_DELIVERY_PRODUCTS)}
    />
  ) : (
    <StyledCartFreeDeliveryWrapper
      data-testid="cart-free-delivery"
      price={priceProductsSummary - discountWithoutDelivery}
      maxLimit={calculateMaxLimit(
        isMinimalPriceLimit,
        minimalPriceLimit,
        freeDelivery,
        freeDeliveryGlobalLimit,
        freeDeliveryGlobalFrom,
        freeDeliveryGlobalTo,
        benefits,
      )}
      messages={messages}
    />
  );
};
